import React from 'react';
import { Typography } from '@/UIlibrary/Typography/Typography';
import {
	Table,
	TableHeader,
	TableBody,
	TableRow,
	TableHead,
	TableCell
} from '@/stories/Shadcn/Table/Table';
import { SyncResult } from '../../CustomerSupport/types';

interface SkippedTemplatesTableProps {
	skippedTemplates: SyncResult['skipped_templates'];
	t: (key: string, params?: any) => string;
}

const SkippedTemplatesTable: React.FC<SkippedTemplatesTableProps> = ({ skippedTemplates, t }) => {
	if (skippedTemplates.length === 0) return null;

	return (
		<div className="mb-6">
			<div className="mb-2 text-gray-700">
				<Typography size="md" weight="medium">
					{t('SkippedTemplates')} ({skippedTemplates.length})
				</Typography>
			</div>
			<div className="max-h-60 overflow-y-auto border rounded">
				<Table>
					<TableHeader>
						<TableRow>
							<TableHead>{t('ClientId')}</TableHead>
							<TableHead>{t('Phone')}</TableHead>
							<TableHead>{t('Reason')}</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{skippedTemplates.map((record, idx) => (
							<TableRow key={idx}>
								<TableCell>{record.client_id}</TableCell>
								<TableCell>{record.phone}</TableCell>
								<TableCell className="text-gray-600">{record.reason}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</div>
		</div>
	);
};

export default SkippedTemplatesTable;
